import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2, MapPin, Building2, Send } from 'lucide-react';
import { partnerPortalAPI } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { ReferDialog } from './ReferDialog';

const SCOPES = [['municipio', 'Meu município'], ['estado', 'Meu estado'], ['todas', 'Todas']];

export const PartnerJobsTab = () => {
  const [scope, setScope] = useState('municipio');
  const [jobs, setJobs] = useState(null);
  const [job, setJob] = useState(null);

  const load = () => { setJobs(null); partnerPortalAPI.jobs(scope).then((r) => setJobs(r.data)).catch(() => toast.error('Erro ao carregar vagas')); };
  useEffect(load, [scope]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Card data-testid="partner-jobs-tab">
      <CardHeader>
        <CardTitle>Indicar para Vagas</CardTitle>
        <CardDescription>Vagas abertas na plataforma. Escolha uma vaga e indique seus candidatos.</CardDescription>
        <div className="flex gap-2 pt-2">
          {SCOPES.map(([k, l]) => (
            <Button key={k} size="sm" variant={scope === k ? 'default' : 'outline'} onClick={() => setScope(k)}
              className={scope === k ? 'bg-amber-500 hover:bg-amber-600' : ''} data-testid={`partner-jobs-scope-${k}`}>{l}</Button>
          ))}
        </div>
      </CardHeader>
      <CardContent>
        {!jobs ? <Loader2 className="w-6 h-6 animate-spin text-amber-500 mx-auto" /> : jobs.length === 0 ? (
          <p className="text-sm text-slate-500 py-6 text-center" data-testid="partner-jobs-empty">Nenhuma vaga aberta neste filtro. Tente ampliar para o estado ou todas.</p>
        ) : (
          <div className="grid md:grid-cols-2 gap-3">
            {jobs.map((j) => (
              <div key={j.id} className="rounded-lg border p-4 flex flex-col gap-2" data-testid={`partner-job-${j.id}`}>
                <p className="font-semibold text-slate-900">{j.titulo}</p>
                <p className="text-xs text-slate-500 flex items-center gap-1"><Building2 className="w-3 h-3" />{j.empresa || 'Empresa'}</p>
                <p className="text-xs text-slate-500 flex items-center gap-1"><MapPin className="w-3 h-3" />{j.localizacao}</p>
                <div className="flex flex-wrap gap-1">
                  {j.tipo_contrato && <Badge variant="outline">{j.tipo_contrato}</Badge>}
                  {j.salario && <Badge variant="outline">{j.salario}</Badge>}
                  {j.minhas_indicacoes > 0 && <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-100">{j.minhas_indicacoes} indicado(s)</Badge>}
                </div>
                <Button size="sm" className="mt-auto bg-amber-500 hover:bg-amber-600" onClick={() => setJob(j)} data-testid={`partner-refer-${j.id}`}>
                  <Send className="w-4 h-4 mr-2" />Indicar candidatos
                </Button>
              </div>
            ))}
          </div>
        )}
      </CardContent>
      <ReferDialog job={job} onClose={() => setJob(null)} onDone={load} />
    </Card>
  );
};
